export const otcMarketplaceAbi = [
    {
        inputs: [
            { internalType: "address", name: "_mcgpToken", type: "address" },
            { internalType: "address", name: "_usdcToken", type: "address" },
        ],
        stateMutability: "nonpayable",
        type: "constructor",
    },
    { inputs: [], name: "EnforcedPause", type: "error" },
    { inputs: [], name: "ExpectedPause", type: "error" },
    {
        inputs: [{ internalType: "address", name: "owner", type: "address" }],
        name: "OwnableInvalidOwner",
        type: "error",
    },
    {
        inputs: [{ internalType: "address", name: "account", type: "address" }],
        name: "OwnableUnauthorizedAccount",
        type: "error",
    },
    { inputs: [], name: "ReentrancyGuardReentrantCall", type: "error" },
    {
        inputs: [{ internalType: "address", name: "token", type: "address" }],
        name: "SafeERC20FailedOperation",
        type: "error",
    },
    {
        anonymous: false,
        inputs: [
            { indexed: true, internalType: "address", name: "buyer", type: "address" },
            { indexed: false, internalType: "uint256", name: "mcgpAmount", type: "uint256" },
            { indexed: false, internalType: "uint256", name: "usdcAmount", type: "uint256" },
            { indexed: true, internalType: "uint256", name: "phaseIndex", type: "uint256" },
        ],
        name: "Bought",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            { indexed: true, internalType: "address", name: "token", type: "address" },
            { indexed: false, internalType: "uint256", name: "amount", type: "uint256" },
        ],
        name: "Funded",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            { indexed: true, internalType: "address", name: "previousOwner", type: "address" },
            { indexed: true, internalType: "address", name: "newOwner", type: "address" },
        ],
        name: "OwnershipTransferred",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [{ indexed: false, internalType: "address", name: "account", type: "address" }],
        name: "Paused",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            { indexed: true, internalType: "bool", name: "isBuyPhase", type: "bool" },
            { indexed: true, internalType: "uint256", name: "newPhaseIndex", type: "uint256" },
        ],
        name: "PhaseChanged",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            { indexed: true, internalType: "bool", name: "isBuyPhase", type: "bool" },
            { indexed: true, internalType: "uint256", name: "phaseIndex", type: "uint256" },
            { indexed: false, internalType: "uint256", name: "newPrice", type: "uint256" },
        ],
        name: "PriceUpdated",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            { indexed: true, internalType: "address", name: "seller", type: "address" },
            { indexed: false, internalType: "uint256", name: "mcgpAmount", type: "uint256" },
            { indexed: false, internalType: "uint256", name: "usdcAmount", type: "uint256" },
            { indexed: true, internalType: "uint256", name: "phaseIndex", type: "uint256" },
        ],
        name: "Sold",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [{ indexed: false, internalType: "address", name: "account", type: "address" }],
        name: "Unpaused",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            { indexed: true, internalType: "address", name: "token", type: "address" },
            { indexed: false, internalType: "uint256", name: "amount", type: "uint256" },
        ],
        name: "Withdrawn",
        type: "event",
    },
    {
        inputs: [],
        name: "MAX_PRICE",
        outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "activeBuyPhaseIndex",
        outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "activeSellPhaseIndex",
        outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            { internalType: "uint256", name: "mcgpAmount", type: "uint256" },
            { internalType: "uint256", name: "maxUsdcAmount", type: "uint256" },
        ],
        name: "buy",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [{ internalType: "uint256", name: "", type: "uint256" }],
        name: "buyPhases",
        outputs: [
            { internalType: "uint256", name: "price", type: "uint256" },
            { internalType: "bool", name: "isActive", type: "bool" },
            { internalType: "bool", name: "isBuyPhase", type: "bool" },
            { internalType: "string", name: "name", type: "string" },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [{ internalType: "uint256", name: "mcgpAmount", type: "uint256" }],
        name: "calculateBuyPrice",
        outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [{ internalType: "uint256", name: "mcgpAmount", type: "uint256" }],
        name: "calculateSellPrice",
        outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            { internalType: "address", name: "token", type: "address" },
            { internalType: "uint256", name: "amount", type: "uint256" },
        ],
        name: "fund",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "getBalances",
        outputs: [
            { internalType: "uint256", name: "mcgpBalance", type: "uint256" },
            { internalType: "uint256", name: "usdcBalance", type: "uint256" },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "getBuyPhases",
        outputs: [
            {
                components: [
                    { internalType: "uint256", name: "price", type: "uint256" },
                    { internalType: "bool", name: "isActive", type: "bool" },
                    { internalType: "bool", name: "isBuyPhase", type: "bool" },
                    { internalType: "string", name: "name", type: "string" },
                ],
                internalType: "struct OtcMarketplace.PricePhase[]",
                name: "",
                type: "tuple[]",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "getSellPhases",
        outputs: [
            {
                components: [
                    { internalType: "uint256", name: "price", type: "uint256" },
                    { internalType: "bool", name: "isActive", type: "bool" },
                    { internalType: "bool", name: "isBuyPhase", type: "bool" },
                    { internalType: "string", name: "name", type: "string" },
                ],
                internalType: "struct OtcMarketplace.PricePhase[]",
                name: "",
                type: "tuple[]",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "mcgpToken",
        outputs: [{ internalType: "contract IERC20", name: "", type: "address" }],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "owner",
        outputs: [{ internalType: "address", name: "", type: "address" }],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "pause",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "paused",
        outputs: [{ internalType: "bool", name: "", type: "bool" }],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "renounceOwnership",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            { internalType: "uint256", name: "mcgpAmount", type: "uint256" },
            { internalType: "uint256", name: "minUsdcAmount", type: "uint256" },
        ],
        name: "sell",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [{ internalType: "uint256", name: "", type: "uint256" }],
        name: "sellPhases",
        outputs: [
            { internalType: "uint256", name: "price", type: "uint256" },
            { internalType: "bool", name: "isActive", type: "bool" },
            { internalType: "bool", name: "isBuyPhase", type: "bool" },
            { internalType: "string", name: "name", type: "string" },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [{ internalType: "uint256", name: "phaseIndex", type: "uint256" }],
        name: "setActiveBuyPhase",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [{ internalType: "uint256", name: "phaseIndex", type: "uint256" }],
        name: "setActiveSellPhase",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [{ internalType: "address", name: "newOwner", type: "address" }],
        name: "transferOwnership",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "unpause",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            { internalType: "bool", name: "isBuyPhase", type: "bool" },
            { internalType: "uint256", name: "phaseIndex", type: "uint256" },
            { internalType: "uint256", name: "newPrice", type: "uint256" },
        ],
        name: "updatePhasePrice",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "usdcToken",
        outputs: [{ internalType: "contract IERC20", name: "", type: "address" }],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            { internalType: "address", name: "token", type: "address" },
            { internalType: "uint256", name: "amount", type: "uint256" },
        ],
        name: "withdraw",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
];
